import { useJobTemporaryFormStore } from '@/store/JobTemporaryFormStore';

export function useJobTemporaryFormData() {
  const { formData, setFormData, clearFormData } = useJobTemporaryFormStore();

  return {
    jobFormData: formData,
    setJobFormData: setFormData,
    clearJobFormData: clearFormData
  };
}
